export const SET_SETTINGS = 'SET_SETTINGS';
export const setSettings = value => ({
	type: SET_SETTINGS,
	value
});

export const SET_DEFAULT_SETTINGS = 'SET_DEFAULT_SETTINGS';
export const setDefaultSettings = value => ({
	type: SET_DEFAULT_SETTINGS,
	value
});

export const SET_INITIAL_SETTINGS = 'SET_INITIAL_SETTINGS';
export const setInitialSettings = () => ({
	type: SET_INITIAL_SETTINGS
});

export const RESET_DEFAULT_SETTINGS = 'RESET_DEFAULT_SETTINGS';
export const resetSettings = value => ({
	type: RESET_DEFAULT_SETTINGS,
	value
});
